export default __webpack_public_path__ + "static/tutorialPicture2-00558809b505b7d0fb3d7a2519463573.jpg";